import { render } from "./docFilters3.vue?vue&type=template&id=73ce08c5"
import script from "./docFilters3.vue?vue&type=script&lang=js"
export * from "./docFilters3.vue?vue&type=script&lang=js"

import "./docFilters3.vue?vue&type=style&index=0&id=73ce08c5&lang=scss"

import exportComponent from "/home/ivan/Downloads/3(1)/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__